<template>
  <div
    class="crime-items d-flex justify-content-between">
    <span class="cirme-wrap d-flex align-items-center gap-3">
      <div class="crime-thumb">
        <img
          class="game-row-img"
          v-lazy="game.thumb_small"
          :alt="game.slug"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div class="crime-content">
        <h6>{{ game.title }}</h6>
        <p>{{ game.categories.map((category) => category.name).join(", ") }}</p>
      </div>
    </span>
    <a
      href="javascript:;"
      class="cmn--btn video-btn"
      @click.prevent="
        $router.push({ name: 'game.show', params: { slug: game.slug } })
      "
    >
      <span> {{ $t("Play") }} </span>
    </a>
  </div>
</template>

<script>
export default {
  name: "GameRow",
  props: {
    game: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.game-row-img {
  width: 85px;
  height: 85px;
  object-fit: cover;
  aspect-ratio: 1 / 1;
}
</style>
